import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AgeRange,
  AvailabilityType,
  ClientDemographic,
  DaysOfWeek,
  Designation,
  Distance,
  Ethnicity,
  Gender,
  InsuranceBilling,
  Language,
  Religion,
  SexualOrientation,
  Specialities,
  Timings,
  TypesOfTherapy,
} from '@therappy-inc/models';
import { filter } from 'rxjs';
import { SharedService } from 'src/app/core/services/shared.service';
import { FilterQuery, FilterService, TherapistFilterProps } from 'src/app/state/search';
import { UserAgentQuery } from 'src/app/state/user-agent';

@UntilDestroy()
@Component({
  selector: 'app-therapist-filter',
  templateUrl: './therapist-filter.component.html',
  styleUrls: ['./therapist-filter.component.scss'],
})
export class TherapistFilterComponent implements OnInit {
  sharedService = inject(SharedService);
  userAgentQuery = inject(UserAgentQuery);
  private readonly filterService = inject(FilterService);
  private readonly filterQuery = inject(FilterQuery);

  activeFilters$ = this.filterQuery.selectActiveFilterKeys();
  hasActiveFilters$ = this.filterQuery.selectHasActiveFilters();

  isPriceRangeMenuOpened = false;
  showPopup = false;

  form = new FormGroup({
    specialities: new FormControl<Specialities[]>([]),
    designation: new FormControl<Designation | null>(null),
    typeOfTherapy: new FormControl<TypesOfTherapy[]>([]),
    isPriceRangeForCouple: new FormControl(false),
    minPrice: new FormControl(0),
    maxPrice: new FormControl(100),
    ageRange: new FormControl<AgeRange | null>(null),
    ethnicity: new FormControl<Ethnicity[]>([]),
    gender: new FormControl<Gender[]>([]),
    language: new FormControl<Language[]>([]),
    religion: new FormControl<Religion[]>([]),
    sexualOrientation: new FormControl<SexualOrientation[]>([]),
    clientDemographic: new FormControl<ClientDemographic[]>([]),
    insurance: new FormControl<InsuranceBilling[]>([]),
    distance: new FormControl<Distance | null>(null),
    availabilityType: new FormControl<AvailabilityType[]>([]),
    daysOfWeek: new FormControl<DaysOfWeek[]>([]),
    timings: new FormControl<Timings[]>([]),
  });

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        untilDestroyed(this),
        filter(() => this.form.valid),
      )
      .subscribe(value => this.filterService.setFilters(value));

    this.filterQuery
      .select('filters')
      .pipe(untilDestroyed(this))
      .subscribe(value => this.form.patchValue(value, { emitEvent: false }));
  }

  removeFilter(key: string): void {
    this.filterService.resetFilter(key as keyof TherapistFilterProps);
  }

  resetFilters(): void {
    this.filterService.reset();
  }

  priceRangeMenuOpened() {
    this.isPriceRangeMenuOpened = true;
  }

  priceRangeMenuClosed() {
    this.isPriceRangeMenuOpened = false;
  }

  openPopup(): void {
    //
  }

  closePopup(): void {
    //
  }

  formatLabel(value: number): string {
    return `$${value}`;
  }
}
